import { CardBody } from 'reactstrap'
import CardItem from '../CardItem/CardItem'
import './MenuCardBody.css'

export default function MenuCardBody({ items }) {
  const cardItems = []
  if (items) {
    items.forEach((item) => {
      cardItems.push(
        <div key={item.id}>
          <CardItem item={item} />
        </div>
      )
    })
  }
  return (
    <CardBody>
      {cardItems}
    </CardBody>
  )
}
